import React, { useState } from "react";
import logoFooter from "../assets/LogoFooter.png";
import GroupLogo from "../assets/GroupLogoFooter.png";
import logoFooterMobile from "../assets/logfooterMobileOne.png";
import logoFooterOne from "../assets/logofooterMobile.png";

const Footer = () => {
  const [isExpanded, setIsExpanded] = useState(false); // Quản lý trạng thái hiển thị nội dung

  const toggleContent = () => {
    setIsExpanded(!isExpanded); // Thay đổi trạng thái khi người dùng nhấn "Xem thêm"
  };
  return (
    <>
      <footer className="md:block hidden">
        <div className="bg-[#303442]  flex flex-col items-center justify-center py-7  ">
          <img src={logoFooter} alt="logo" />
          <div className="flex justify-between gap-5 text-[16px] text-[#868DA5] my-7">
            <p>Giới thiệu về RR88</p>|<p>Điều khoản & điều kiện</p>|
            <p>Chơi có trách nhiệm</p>|<p>Miễn trách nhiệm</p>|
            <p>Quyền riêng tư</p>|<p>Hướng dẫn nạp rút</p>|
            <p>Câu hỏi thường gặp</p>|<p>Liên hệ</p>
          </div>
          <img src={GroupLogo} alt="GroupLogo" />
        </div>
      </footer>
      {/* mobile */}
      <footer className="md:hidden block">
        <div
          className={`bg-[#303442]  text-[#868DA5]  flex flex-col items-center justify-center py-7  flex flex-col items-center bg-cover bg-center py-4`}
        >
          <img src={logoFooter} alt="logo" className="!w-[15rem] mb-5" />
        {/* Nội dung Footer - Mobile */}
        <div className="flex flex-col items-center space-y-2 px-3 text-[11px]">
          {/* Hàng 1 */}
          <div className="flex items-center justify-center">
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Giới thiệu về RR88</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Điều khoản & điều kiện</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Chơi có trách nhiệm</a>
          </div>

          {/* Hàng 2 */}
          <div className="flex items-center justify-center">
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Miễn trách nhiệm</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Quyền riêng tư</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Hướng dẫn nạp rút</a>
          </div>

          {/* Hàng 3 */}
          <div className="flex items-center justify-center">
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Câu hỏi thường gặp</a>
            <span className="text-[#868DA5] mx-1">|</span>
            <a href="#" className="hover:underline text-[#868DA5] whitespace-nowrap">Liên hệ</a>
          </div>
        </div>
          <img src={logoFooterMobile} alt="photo" className="my-5 w-full" />
          <img src={logoFooterOne} alt="photo" className=" w-full" />
        </div>
      </footer>
    </>
  );
};

export default Footer;
